const fonts = {
    body: 'Open Sans, sans-serif',
    heading: 'Roboto Slab, serif',
    mono: 'Open Sans, sans-serif',
};

export default fonts;
